import React from 'react';

function MenuBar(props:any) {
    return (
        <div id="menu-bar" style={{margin: "auto"}}> 🚧 App Under Construction... 🚧 </div>
    )
}

export default MenuBar;